import { AppPageContentWrapper, CircularTextLoader, PageContentBox, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";
import { resetRegprofAdditionalDocRequest } from "../../../../store/redux/slice/Forms/regprofAdditionalDocForm";

const RegprofAdditionalDocNew = () => {
  const dispatch = useAppDispatch();

  const regprofAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.RegprofAdditionalDocForm;
  });

  useEffect(() => {
    dispatch(resetRegprofAdditionalDocRequest());
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {regprofAdditionalDocForm.dataStateStatus === THUNK_STATUS.INITIAL ? (
            <ServiceStepper
              serviceSteps={regprofAdditionalDocForm.steps}
              applicationSubtype={"REGPROF_ADDITIONAL_DOCUMENTS"}
            />
          ) : (
            <CircularTextLoader />
          )}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default RegprofAdditionalDocNew;
